import { Component } from '@angular/core';
import { generateId } from '../../../server/services/utils.service';

@Component({
  selector: 'app-log-in-google-button',
  templateUrl: './log-in-google-button.component.html',
  styleUrls: ['./log-in-google-button.component.scss'],
  standalone: false,
})
export class LogInGoogleButtonComponent {
  goToUrl() {
    const origin =
      window.location.origin === 'http://localhost:4200'
        ? 'http://localhost:3000'
        : window.location.origin;

    const cacheBust = generateId();

    const url =
      origin + '/auth/google/redirect/' + cacheBust + '?ngsw-bypass=true';

    window.location.href = url;
  }
}
